'use client';
import dynamic from 'next/dynamic';

import Image from 'next/image';
import logo from '@/assets/images/logo.png';
import { mapModifiers } from '@/utils/funtion';
import '@/styles/global.scss';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'next/navigation';
import { signOut } from '@/services/apis/modules/auth';
import { signOut as signOutNextAuth } from 'next-auth/react';
const SignUp = dynamic(() => import('@/components/templates/signUp'), {
  ssr: false,
});
const SignIn = dynamic(() => import('@/components/templates/signIn'), {
  ssr: false,
});
const ForgetPassword = dynamic(
  () => import('@/components/templates/forgetPassword'),
  { ssr: false },
);
const Button = dynamic(() => import('@/components/atoms/button'), {
  ssr: false,
});
const Icon = dynamic(() => import('@/components/atoms/icon'), { ssr: false });

export default function Auth() {
  const searchParams = useSearchParams();
  const [tabId, setTabId] = useState(0);
  const [isLogout, setIsLogout] = useState(false);

  const formAuthen = [
    {
      id: 0,
      key: 'signin',
      component: <SignIn handleChangeForm={(value) => setTabId(value)} />,
    },
    {
      id: 1,
      key: 'signup',
      component: <SignUp handleChangeForm={(value) => setTabId(value)} />,
    },
    {
      id: 2,
      key: 'forget',
      component: (
        <ForgetPassword handleChangeForm={(value) => setTabId(value)} />
      ),
    },
  ];

  const handleLogOut = async () => {
    if (isLogout) return;
    await signOut().then(async () => {
      await signOutNextAuth();
      localStorage.clear();
      sessionStorage.clear();
      sessionStorage.setItem('unauthorized', 'true');
      setIsLogout(true);
    });
  };

  useEffect(() => {
    const getUnauthorized = sessionStorage.getItem('unauthorized');
    if (getUnauthorized === 'true') return;
    if (isLogout) return;
    const typeAuth = searchParams?.get('type');
    if (!typeAuth) return;
    if (typeAuth !== 'unauthorized') return;
    handleLogOut();
  }, []);

  return (
    <div>
      <main className={mapModifiers('p-auth', formAuthen[tabId]?.key)}>
        <div className="p-auth_back">
          <Button
            shape="fill"
            ariaLabel="Menu"
            variant="secondary"
            onClick={() => {
              window.location.href = '/';
            }}
          >
            <Icon iconName="burger" size="30x30" />
          </Button>
        </div>
        <article>
          {formAuthen.map((i) => {
            return (
              <div
                key={i.id}
                className={mapModifiers(
                  `p-auth_cpn_${i.key}`,
                  i.id === tabId ? 'active' : 'disable',
                )}
              >
                {i.component}
              </div>
            );
          })}
          <div className={mapModifiers('p-auth_bg', formAuthen[tabId]?.key)} />
          <div className={mapModifiers('p-auth_logo', formAuthen[tabId]?.key)}>
            <Image src={logo} alt="logo" loading="lazy" />
          </div>
        </article>
      </main>
    </div>
  );
}
